import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { initializeEnv } from './config/env';
import { reloadOnceOnStaleChunk } from './utils/stale-chunk';

// Toggle-theme feature removed: scrub any leftover `.dark` class so users
// whose <html> got stuck in dark mode pre-removal recover on next load.
document.documentElement.classList.remove('dark');

// ── Handle stale chunk errors after deploy ──────────────────
// When a new deploy changes JS chunk hashes, users with cached HTML
// will try to load old chunks that no longer exist on S3.
// This handler auto-reloads the page once to fetch fresh assets.
window.addEventListener('error', (event) => {
  reloadOnceOnStaleChunk(event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  reloadOnceOnStaleChunk(event.reason);
});

// Initialize and validate environment configuration
try {
  initializeEnv();
} catch (error) {
  console.error('Environment validation failed:', error);
  // Show error to user
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: system-ui;">
      <div style="text-align: center; max-width: 600px; padding: 2rem;">
        <h1 style="color: #dc2626; margin-bottom: 1rem;">Configuration Error</h1>
        <p style="color: #374151; margin-bottom: 1rem;">
          The application is missing required environment variables. Please check your configuration.
        </p>
        <pre style="background: #f3f4f6; padding: 1rem; border-radius: 0.5rem; text-align: left; overflow-x: auto;">
${error instanceof Error ? error.message : 'Unknown error'}
        </pre>
      </div>
    </div>
  `;
  throw error;
}

// Log API configuration
function logApiConfiguration() {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1';
  
  console.log('%c[API] Connecting to API Gateway', 'color: #3b82f6; font-weight: bold');
  console.log(`[API] Base URL: ${apiBaseUrl}`);
}

// Start application
logApiConfiguration();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
